import __vue_component__ from '../Button/Button.vue.js';

//
var script = {
  name: 'Day',
  components: {
    Button: __vue_component__
  },
  props: {
    day: {
      type: Object,
      required: true
    }
  },
  computed: {
    date() {
      return this.day.date.getDate();
    },

    isDisabled() {
      return this.day.isDisabled;
    },

    isHighlighted() {
      return this.day.isHighlighted;
    },

    isRangeStart() {
      return this.day.isRangeStart;
    },

    isRangeEnd() {
      return this.day.isRangeEnd;
    }

  },
  methods: {
    onDateSelected() {
      this.$emit('date-selected', this.day);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Day.vue_rollup-plugin-vue=script.js